module.exports = __webpack_public_path__ + "img/document.dd49d7c9.png";